<template>
  <div class="app">
    <CampaignCardList class="campaign-card-list" :campaigns="campaigns" />
    <ButtonLink
      class="button-link"
      v-if="campaigns.length > 0"
      :href="linkToAssociateSite"
      >もっとキャンペーンを見る</ButtonLink
    >
  </div>
</template>

<script>
import CampaignCardList from '@/components/CampaignCardList';
import { RequestHelper } from '@/request-helper';
import ButtonLink from '@/components/ButtonLink';

async function fetchCampaigns() {
  const rawQueryParam = window.location.search; // ?付きのクエリパラメータ, string
  return RequestHelper.get(`campaign${rawQueryParam}`);
}

export default {
  name: 'App',
  components: {
    ButtonLink,
    CampaignCardList,
  },
  data() {
    return {
      campaigns: [],
    };
  },
  computed: {
    linkToAssociateSite() {
      if (this.campaigns.length === 0) {
        return '';
      }

      const associate_uid = this.campaigns[0]['associate']['associate_uid'];
      return `https://syncable.biz/associate/${associate_uid}/campaign`;
    },
  },
  async mounted() {
    const response = await fetchCampaigns();
    this.campaigns = response.data['results'];
  },
};
</script>

<style lang="scss">
@import '~ress/dist/ress.min.css';
@import 'assets/css/global.scss';
</style>

<style scoped lang="scss">
.app {
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;

  padding: 8px 0 0 8px;
}
.button-link {
  margin: 10px auto 0 auto;
}
</style>
